// extracted by mini-css-extract-plugin
export default {"section":"Categories_section__EQOcW","grid":"Categories_grid__GOjS6","chip":"Categories_chip__UcZ-e","visible":"Categories_visible__-lJWt"};